module.exports = __webpack_public_path__ + "img/center_beijing.78ff8b1b.png";